import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { GetCurrencyTypeListPagingAndFilterRequest } from '../models/request/currencyType/GetCurrencyTypeListPagingAndFilterRequest';

export class CurrencyTypeService {
    static async getCurrencyTypeListPagingAndFilter(inputObj: GetCurrencyTypeListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetCurrencyTypeListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CurrencyType/GetCurrencyTypeListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportCurrencyTypeList(inputObj: GetCurrencyTypeListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportCurrencyTypeList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CurrencyType/exportCurrencyTypeList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getCurrencyTypeList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getCurrencyTypeList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CurrencyType/getCurrencyTypeList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteCurrencyType(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteCurrencyType', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CurrencyType/deleteCurrencyType', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getCurrencyTypeById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getCurrencyTypeById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CurrencyType/getCurrencyTypeById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}